var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _c(
        "el-row",
        { staticClass: "mb-20", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card visit" }, [
              _c("div", { staticClass: "card-title" }, [_vm._v("在线乘客数")]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.passengerOnline)),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card turnover" }, [
              _c("div", { staticClass: "card-title" }, [
                _vm._v("今日乘客注册量"),
              ]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.passengerRegister)),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card download" }, [
              _c("div", { staticClass: "card-title" }, [_vm._v("在线司机数")]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.driverOnline)),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card deal" }, [
              _c("div", { staticClass: "card-title" }, [
                _vm._v("今日司机注册量"),
              ]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.driverRegister)),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card driverOnline" }, [
              _c("div", { staticClass: "card-title" }, [
                _vm._v("今日司机总在线时长"),
              ]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.driverOnlineTime) + "/分钟"),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card passengerH5Register" }, [
              _c("div", { staticClass: "card-title" }, [
                _vm._v("今日乘客H5注册数量"),
              ]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.passengerH5Register)),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card passengerAndroidRegister" }, [
              _c("div", { staticClass: "card-title" }, [
                _vm._v("今日乘客Android注册数量"),
              ]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.passengerAndroidRegister)),
              ]),
            ]),
          ]),
          _c("el-col", { attrs: { span: 6 } }, [
            _c("div", { staticClass: "card passengerIOSRegister" }, [
              _c("div", { staticClass: "card-title" }, [
                _vm._v("今日乘客IOS注册数量"),
              ]),
              _c("div", { staticClass: "card-value" }, [
                _vm._v(_vm._s(_vm.passengerIOSRegister)),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 14 } }, [
            _c("div", { ref: "lineChart", staticClass: "chart-box" }),
          ]),
          _c("el-col", { attrs: { span: 10 } }, [
            _c("div", { ref: "pieChart", staticClass: "chart-box" }),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }